import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './policy.module.css';

/**
 * 이용약관.
 *
 * 2026-10-09 처음 만들었다(전자결제 심사·전자상거래법상 사이트 표시 항목).
 * 취소·환불 숫자는 여기 다시 적지 않고 고객센터 화면(/center#refund)을 가리킨다 —
 * 두 군데 적으면 한쪽만 고쳐져 서로 어긋난다.
 */
export default function Terms({ companyData = {} }) {
  useEffect(() => {
    const titleElement = document.querySelector('title');
    titleElement.innerHTML = `이케이하나관광-이용약관`;
    // 하단 링크로 들어오므로, 그대로 두면 새 화면이 맨 아래에서 열린다.
    window.scrollTo(0, 0);
  }, []);

  const tel = companyData.tel || '';

  return (
    <main className={styles.policy}>
      <h1 className={styles.title}>이용약관</h1>

      <section className={styles.section}>
        <h2 className={styles.heading}>제1조 (목적)</h2>
        <p className={styles.text}>
          이 약관은 주식회사 이케이투어(이하 «회사», 브랜드명 이케이하나관광)가 운영하는 홈페이지(www.ekhanabus.com)에서
          제공하는 전세버스 견적·예약 서비스의 이용 조건과 회사와 고객의 권리·의무를 정합니다.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제2조 (약관의 효력과 변경)</h2>
        <p className={styles.text}>
          이 약관은 홈페이지에 게시함으로써 효력이 생깁니다. 회사는 관련 법령을 위반하지 않는 범위에서 약관을 바꿀 수 있으며,
          바꿀 때에는 시행일 7일 전부터 홈페이지에 알립니다. 이미 체결된 운송 계약에는 계약 당시의 약관이 적용됩니다.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제3조 (서비스 내용)</h2>
        <ul className={styles.list}>
          <li>전세버스 대절 견적요청 접수와 견적서 제공(문자·이메일·전화)</li>
          <li>나의견적확인: 휴대폰 문자 인증 후 본인 견적요청의 조회·수정·취소</li>
          <li>운송 계약 체결과 요금 결제 안내</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제4조 (견적과 계약의 성립)</h2>
        <ul className={styles.list}>
          <li>
            홈페이지의 견적요청은 상담 신청이며, 그 자체로 운송 계약이 성립하지 않습니다.
          </li>
          <li>
            견적 금액은 운행 일정·거리·차종·성수기 여부에 따라 달라지며, 회사가 보낸 견적서의 금액과 조건이 기준입니다.
          </li>
          <li>
            운송 계약은 고객이 견적 내용에 동의하고 계약금을 낸 때(또는 계약서를 작성한 때) 성립합니다.
          </li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제5조 (요금과 결제)</h2>
        <ul className={styles.list}>
          <li>
            견적 금액에는 따로 적지 않는 한 유류비·통행료·주차비가 포함되며, 기사 봉사료·숙식비는 별도입니다.
          </li>
          <li>모든 가격은 부가가치세 별도입니다.</li>
          <li>
            요금은 계좌이체 또는 신용카드(회사가 보내 드리는 결제 링크)로 낼 수 있습니다.
            카드 결제는 결제대행사(토스페이먼츠)를 통해 처리됩니다.
          </li>
          <li>계약금과 잔금의 금액·납부 시기는 견적서 또는 계약서에 따릅니다.</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제6조 (취소와 환불)</h2>
        <p className={styles.text}>
          고객의 사정으로 계약을 취소하는 경우의 환불은 회사의{' '}
          <Link className={styles.link} to='/center#refund'>취소 및 환불규정</Link>에 따릅니다.
          회사의 사정(차량 고장, 배차 불가 등)으로 운행하지 못한 경우에는 받은 금액 전액을 돌려 드립니다.
        </p>
        <p className={styles.text}>
          카드로 결제한 금액의 환불은 결제 취소로 처리하며, 카드사 사정에 따라 취소 반영까지 영업일 기준 3~7일이 걸릴 수 있습니다.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제7조 (회사의 의무와 책임)</h2>
        <ul className={styles.list}>
          <li>회사는 「여객자동차 운수사업법」 등 관련 법령을 지키며, 보험에 가입된 차량과 자격을 갖춘 운전기사를 배차합니다.</li>
          <li>
            천재지변, 교통 통제, 사고 등 회사가 통제할 수 없는 사유로 일정이 늦어지거나 바뀐 경우,
            회사는 고의 또는 과실이 없는 한 그로 인한 손해를 책임지지 않습니다.
          </li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제8조 (고객의 의무)</h2>
        <ul className={styles.list}>
          <li>견적요청 시 정확한 정보를 적어야 하며, 다른 사람의 정보를 쓰면 안 됩니다.</li>
          <li>차량 안에서 운전기사의 안전 안내에 따라야 하며, 고객의 잘못으로 차량이 훼손된 경우 그 손해를 배상합니다.</li>
          <li>홈페이지 운영을 방해하는 행위(자동화된 대량 요청, 공격 시도 등)를 하면 이용이 제한될 수 있습니다.</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제9조 (개인정보 보호)</h2>
        <p className={styles.text}>
          회사는 고객의 개인정보를 <Link className={styles.link} to='/privacy'>개인정보처리방침</Link>에 따라 처리합니다.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>제10조 (분쟁 해결)</h2>
        <p className={styles.text}>
          서비스 이용과 관련한 불만은 고객센터(전화 {tel})로 접수하시면 신속히 처리합니다.
          이 약관에 정하지 않은 사항은 전세버스 운송사업 표준약관과 관련 법령, 상관례에 따릅니다.
          분쟁에 관한 소송은 「민사소송법」에 따른 관할 법원에 제기합니다.
        </p>
      </section>

      <p className={styles.effective}>시행일: 2026년 10월 9일</p>
    </main>
  );
}
